import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { toggleFormCourse } from '../../../../../../redux/actions/courses'
import { showLesson, toggleFormLesson } from '../../../../../../redux/actions/lessons'
import DetailHeroPanel from '../../../../../shared/components/DetailHeroPanel'
import DetailInfoPanel from '../../../../../shared/components/DetailInfoPanel'
import ShareIcon from '../../../../../shared/components/icons/ShareIcon'
import { MoreInfoDetail } from '../../../../library/models/resource'

interface CourseDetailSidebarProps {
  course: any
  lesson: any
  isLesson: boolean
  favoriteState: boolean
  handleFavoriteClick: (id: number) => (state: boolean) => void
  infoDetail: MoreInfoDetail
}

const CourseDetailSidebar = ({ course, lesson, isLesson, favoriteState, handleFavoriteClick, infoDetail }: CourseDetailSidebarProps) => {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  return (
    <>
      <DetailHeroPanel
        visibility={course.visibility}
        brand={course?.brand?.name}
        title={isLesson ? lesson.title : course.title}
        author={course.responsibles.length > 0 ? course.responsibles[0].name : null}
        statusC={
          <>
            {(isLesson ? lesson.status : course.status) === 0 && `${t('inactive')}`}
            {(isLesson ? lesson.status : course.status) === 1 && `${t('active')}`}
            {(isLesson ? lesson.status : course.status) === 2 && `${t('draft')}`}
          </>
        }
        description={course.description !== 'null' ? course.description : null}
        edit={() => {
          isLesson ? dispatch(showLesson(lesson.id)) : dispatch(toggleFormCourse())
        }}
        add={() => {
          dispatch(toggleFormLesson())
        }}
        onClickFavorite={handleFavoriteClick(course.id)}
        favoriteState={favoriteState}
        share={
          <ShareIcon
            meta={true}
            visibility={course.visibility}
            title={course.title}
            description={course.description || ''}
            link={window.location.href}
            multimedia={`${course.image_url}?${Date.now()}`}
            component="buttonTextGreen"
            type="course"
            buttonTextGreen={t('share')}
          />
        }
        data={{ add: 'addlesson', edit: 'editcourse' }}
      />
      <DetailInfoPanel attributes={infoDetail} />
    </>
  )
}

export default CourseDetailSidebar
